import Marquee from "react-fast-marquee";
import { Zap } from "lucide-react";

const items = ["SELL", "BUY", "EXCHANGE", "DEAL 2 WHEEL"];

export const EditorialMarquee = ({ className = "" }) => (
  <div className={`border-y border-white/10 bg-[#070707] py-6 md:py-8 overflow-hidden ${className}`} data-testid="editorial-marquee">
    <Marquee speed={32} gradient={false} className="marquee-motion">
      {items.concat(items).map((item, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span
            className={`font-display font-semibold uppercase text-4xl md:text-6xl tracking-tighter px-6 md:px-10 ${
              i % 2 === 0 ? "text-white" : "text-outline-volt"
            }`}
          >
            {item}
          </span>
          <Zap className="w-7 h-7 md:w-9 md:h-9 text-volt fill-volt shrink-0" />
        </span>
      ))}
    </Marquee>
  </div>
);

export default EditorialMarquee;
